// File: src/app/admin/service/product-group.service.ts
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { AdminCommonHttpService } from './admin-common-http.service';

export interface ProductGroup {
  id: string;
  name: string;
  description?: string;
}

@Injectable({ providedIn: 'root' })
export class ProductGroupService {
  constructor(private commonHttp: AdminCommonHttpService) { }

  async createGroup(data: { name: string; description?: string }): Promise<ProductGroup> {
    return await this.commonHttp.createProductGroup(data.name, data.description || '')

  }

  async getAllGroups(): Promise<ProductGroup[]> {
    return await this.commonHttp.getAllGroups();
  }

  async updateGroup(id: string, data: { name: string; description?: string }): Promise<ProductGroup> {
    return await this.commonHttp.updateProductGroup(id, data.name, data.description || '');
  }

  async deleteGroup(id: string): Promise<void> {
    return await this.commonHttp.deleteProductGroup(id);
  }

  async assignProductToGroup(productId: string, groupId: string): Promise<any> {
    return await this.commonHttp.assignProductToGroup(productId, groupId);
  }

  async assignProductsToGroup(selectedProducts: any, group_ids: any) {
    return await this.commonHttp.assignProductsToGroup(selectedProducts, group_ids)
  }

  async getProductsInGroup(group_ids: any) {
    return await this.commonHttp.getAllProductsInGroup(group_ids)
  }


}
